import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export function Hero() {
  return <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden bg-gradient-to-b from-cream to-sage-light py-20 px-6" data-id="element-66">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-67">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] rounded-full bg-gold/5 blur-3xl" data-id="element-68"></div>
        <div className="absolute bottom-[-10%] right-[-10%] w-[50%] h-[50%] rounded-full bg-sage/5 blur-3xl" data-id="element-69"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-70">
        <FadeIn delay={0.1} data-id="element-71">
          <span className="inline-block py-1 px-4 rounded-full bg-sage/10 text-sage font-medium text-sm tracking-wider uppercase mb-8" data-id="element-72">
            Para tu tranquilidad y la de ellos
          </span>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-73">
          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-charcoal leading-tight mb-8" data-id="element-74">
            El Regalo de la Tranquilidad: <br className="hidden md:block" data-id="element-75" />
            <span className="text-sage italic" data-id="element-76">
              Organiza tu "Legado en Vida"
            </span>{' '}
            hoy mismo.
          </h1>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-77">
          <h2 className="text-xl md:text-2xl text-muted font-light max-w-3xl mx-auto leading-relaxed mb-12" data-id="element-78">
            No dejes que tus hijos hereden un rompecabezas de papeles y
            contraseñas. Dales el mapa que necesitan para cuidarte (y
            recordarte) sin estrés.
          </h2>
        </FadeIn>

        <FadeIn delay={0.6} data-id="element-79">
          <div className="flex flex-col items-center gap-4" data-id="element-80">
            <Button scrollTo="offer" data-id="element-81">Empieza Ahora</Button>
            <p className="text-sm text-muted mt-2" data-id="element-82">
              Descarga inmediata • Guía paso a paso
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}